import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const reviewsData = [
    {
        id: 1,
        quote: "We got our MVP + 5 client meetings in 45 days. They co-built everything.",
        img: "img/bid-your-stay.png",
        author: "Founder, BidYourStay"
    },
    {
        id: 2,
        quote: "Turningideas helped us to get funding ready and help raise our first pressed round in 2 months  Neelesh Verma Founder Intellidb",
        img: "img/logos/intellidb.png",
        author: "Founder, IntelliDb"
    }
];

const Reviews = () => {
    const sectionRef = useRef(null);
    const headingRef = useRef(null);
    const cardsRef = useRef([]);

    useEffect(() => {
        const ctx = gsap.context(() => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%", // Animation starts when top of section hits 80% of viewport
                    toggleActions: "play none none none",
                }
            });

            // 1. Heading Fade Up
            tl.from(headingRef.current, {
                y: 40,
                opacity: 0,
                duration: 0.6,
                ease: "power2.out"
            });

            // 2. Review Cards "Bounce" In
            tl.from(cardsRef.current, {
                y: 60,       // Come from further down
                scale: 0.95, // Start slightly smaller
                opacity: 0,
                duration: 0.8,
                stagger: 0.2, // Delay between the first and second card
                ease: "back.out(1.5)" // This gives it the "bouncy" friendly feel
            }, "-=0.3"); // Overlap slightly with the heading animation

        }, sectionRef);

        return () => ctx.revert();
    }, []);

    // Helper to add refs
    const addToRefs = (el) => {
        if (el && !cardsRef.current.includes(el)) {
            cardsRef.current.push(el);
        }
    };

    return (
        <section ref={sectionRef} className='flex flex-col gap-y-8 container max-w-7xl mx-auto px-6 md:px-12 my-[100px]'>
            <h3 
                ref={headingRef} 
                className='text-center text-[#111827] font-[600] text-[34px] sm:text-[40px] -tracking-[1.2px]'
            >
                What founders say about us
            </h3>
            
            <ol className='grid sm:grid-cols-2 gap-7'>
                {reviewsData.map((review, index) => (
                    <li key={index} ref={addToRefs}>
                        <article className='bg-white rounded-[30px] px-8 py-10 h-full shadow-sm hover:shadow-md transition-shadow duration-300'>
                            <h4 
                                className='text-[#030303] text-[20px] leading-[33.6px] -tracking-[0.5px] font-[600]' 
                                style={{ fontFamily: 'Urbanist' }}
                            >
                                {review.quote}
                            </h4>
                            <div className='grid grid-cols-[max-content_1fr] gap-x-4 mt-7 items-center'>
                                <span className='w-14 h-14 bg-[#F3F4F6] p-1 flex items-center justify-center rounded-full'>
                                    <img 
                                        src={review.img} 
                                        alt="Client Logo" 
                                        className='object-scale-down w-full h-full' 
                                    />
                                </span>
                                <span 
                                    className='text-[#030303] text-[16px] font-[600] leading-[27.2px]' 
                                    style={{ fontFamily: 'Urbanist' }}
                                >
                                    {review.author}
                                </span>
                            </div>
                        </article>
                    </li>
                ))}
            </ol>
        </section>
    );
}

export default Reviews;